import type { Balance } from '@src/types';
import {
  getReconStatusWarningSeverity,
  isPositionWarning,
  PositionWarnings,
  type PositionReconStatus,
  type PositionWarning,
} from '@talos/kyoko';

export type BalanceWarningSource = Pick<Balance, 'Currency'> & {
  ReconStatus?: PositionReconStatus;
  reconWarning?: PositionWarning;
};

export function getBalanceWarning(data: BalanceWarningSource): PositionWarning | undefined {
  const existingWarning = data.reconWarning;
  if (isPositionWarning(existingWarning)) {
    return existingWarning;
  }

  if (data.ReconStatus == null) {
    return undefined;
  }

  const severity = getReconStatusWarningSeverity(data.ReconStatus.Status);
  if (severity == null) {
    return undefined;
  }

  return {
    severity,
    asset: data.Currency,
    reconStatus: data.ReconStatus,
  };
}

export function renderBalanceWarningDetails(data: Balance) {
  const warning = getBalanceWarning(data);
  return warning == null ? null : <PositionWarnings warning={warning} variant="mobileDetail" />;
}
